export default __webpack_public_path__ + "static/media/nHubano.d5b1d81a.jpg";